/**
 * ユーザです。
 */
export interface User {
  /** Id */
  id: number;
  /** userId */
  userId: string;
  /** 苗字 */
  familyName: string;
  /** 名前 */
  givenName: string;
  /** ロール(1:管理者,2:一般ユーザー) */
  role: number;
  /** SuperUserフラグ */
  superUser: boolean;
}

export function isAdmin(user: User | undefined) {
  return user?.role === 1;
}
